<template>
  <div class="ach-payment">
    <div class="ach-container" id="ach-container"></div>
  </div>
</template>

<script>
import indexMixin from "../../mixins/index";
export default {
  name: "AchPaymentComponent",
  mixins: [indexMixin],
  props: {
    environment: {
      type: String,
      default: "test"
    },
    clientKey: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      achPaymentComponent: null,
      checkoutAttemptId: null,
      paymentMethod: null
    };
  },
  emits: [
    "payment-completed",
    "payment-error",
    "payment-submit",
    "payment-change"
  ],
  methods: {
    /**
     * 生成唯一标识符作为 checkoutAttemptId
     */
    generateCheckoutAttemptId() {
      return `${Date.now()}-${Math.random()
        .toString(36)
        .substring(2, 15)}`;
    },

    /**
     * @method initAchPayment
     * @description 初始化ACH支付组件
     */
    async initAchPayment() {
      let _this = this;
      console.log(window.AdyenCheckout, "AdyenCheckout");

      // 生成 checkoutAttemptId
      this.checkoutAttemptId = this.generateCheckoutAttemptId();

      // Adyen 需要正确的 paymentMethodsResponse 格式
      const configuration = {
        paymentMethodsResponse: {
          groups: [],
          paymentMethods: [
            {
              type: "ach",
              name: "ACH"
            }
          ]
        },
        // paymentMethodsConfiguration: {
        //   ach: {
        //     holderNameRequired: false,
        //     showBankLocationField: false,
        //     billingAddressRequired: true,
        //   }
        // },
        analytics: {
          enabled: true,
          checkoutAttemptId: this.checkoutAttemptId
        },
        showPayButton: false,
        locale: "en_US",
        bankAccount: {
          prefilledValue: {
            ownerName: ""
          }
        },
        recurringProcessingModel: "Subscription",
        environment: this.environment,
        clientKey: this.clientKey,
        // Adyen 5.53.2版本的正确回调函数名
        onAdditionalDetails: (state, component) => {
          console.log(state, component, "onAdditionalDetails");
        },
        onSubmit: (state, component) => {
          console.log(state, component, "onSubmit");
          this.$emit("payment-submit", state);
          this.reportLog({
            eventId: "PAYSUBMIT_H5_subscription",
            msg: ""
          });
        },
        onChange: (state, component) => {
          console.log(state, component, "onChange");
          if (state.data && state.data.paymentMethod) {
            _this.paymentMethod = state.data.paymentMethod;
            this.$emit("payment-change", state);
          }
          this.reportLog({
            eventId: "BINDPAY_subscription",
            msg: ""
          });
        },
        onError: (error, component) => {
          console.error(error, component, "onError");
          this.$emit("payment-error", error);
        }
      };
      try {
        if (!window.AdyenCheckout) {
          console.error("AdyenCheckout is not loaded");
          this.loadAdyenScript();
          return;
        }
        const achConfiguration = {
          holderNameRequired: true,
          bankAccountRequired: false,
          billingAddressRequired: false
        };
        const checkout = await new window.AdyenCheckout(configuration);
        _this.achPaymentComponent = checkout
          .create("ach", achConfiguration)
          .mount("#ach-container");
        console.log("ACH component mounted successfully");
      } catch (error) {
        console.error("Error initializing Adyen checkout:", error);
        this.$emit("payment-error", error);
      }
    },

    /**
     * 动态加载 Adyen 脚本
     */
    loadAdyenScript() {
      const script = document.createElement("script");
      // 根据环境选择不同的脚本
      script.src = `https://checkoutshopper-${this.environment}.adyen.com/checkoutshopper/sdk/5.53.2/adyen.js`;
      script.integrity = "";
      script.crossOrigin = "anonymous";
      script.onload = () => {
        console.log("Adyen SDK loaded successfully");
        this.initAchPayment();
      };
      script.onerror = error => {
        console.error("Failed to load Adyen SDK", error);
        this.$emit("payment-error", { type: "script_load_error", error });
      };

      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = `https://checkoutshopper-${this.environment}.adyen.com/checkoutshopper/sdk/5.53.2/adyen.css`;
      link.integrity = "";
      link.crossOrigin = "anonymous";

      document.head.appendChild(script);
      document.head.appendChild(link);
    },

    /**
     * 获取当前支付方法数据
     * @returns {Object} 支付方法数据
     */
    getPaymentMethod() {
      return this.paymentMethod;
    },

    /**
     * 手动提交支付表单
     */
    submitPayment() {
      if (this.achPaymentComponent) {
        this.achPaymentComponent.submit();
      } else {
        console.error("ACH payment component not initialized");
      }
    }
  },
  mounted() {
    if (window.AdyenCheckout) {
      this.initAchPayment();
    } else {
      console.log("Adyen script is not loaded, attempting to load it now");
      this.loadAdyenScript();
    }
  }
};
</script>

<style lang="less">
.ach-payment {
  padding: 20px;
  // max-width: 500px;
  margin: 0 auto;
}
#ach-container {
  min-height: 300px;
}
.adyen-checkout-form-instruction {
  display: none;
}

/* 增加了选择器特异性，确保能覆盖Adyen默认样式 */
.ach-card-list-component .adyen-checkout__fieldset__title,
.ach-card-list-component .adyen-checkout__label__text,
#ach-container .adyen-checkout__fieldset__title,
#ach-container .adyen-checkout__label__text {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #333 !important;
  margin-bottom: 5px !important;
}

/* 添加更多Adyen组件样式覆盖 */
#ach-container .adyen-checkout__input {
  height: 40px !important;
  font-size: 14px !important;
  border-radius: 4px !important;
  border: 1px solid #ddd !important;
}

// #ach-container .adyen-checkout__input:focus {
//   border-color: #ffaa0a !important;
//   box-shadow: 0 0 0 2px rgba(255, 170, 10, 0.2) !important;
// }

#ach-container .adyen-checkout__button {
  background-color: #ffaa0a !important;
  color: white !important;
}

/* 修正字段间距 */
#ach-container .adyen-checkout__field {
  margin-bottom: 16px !important;
}
</style>
